const LEGACY_MEDIA_HOST = 'social.loopino.ai';

const isDataUrl = (value) => typeof value === 'string' && value.startsWith('data:');
const isBlobUrl = (value) => typeof value === 'string' && value.startsWith('blob:');

export function normalizeMediaUrl(value, apiBaseUrl) {
  if (typeof value !== 'string') return value;

  const trimmed = value.trim();
  if (!trimmed) return value;
  if (isDataUrl(trimmed) || isBlobUrl(trimmed)) return trimmed;
  if (!trimmed.toLowerCase().includes(LEGACY_MEDIA_HOST)) return trimmed;

  let target;
  try {
    target = apiBaseUrl ? new URL(apiBaseUrl) : null;
  } catch {
    target = null;
  }

  const targetProtocol = target?.protocol || 'https:';
  const targetHostname = target?.hostname || 'loopino.ai';
  const targetPort = target?.port || '';

  try {
    const parsed = new URL(trimmed.startsWith('//') ? `${targetProtocol}${trimmed}` : trimmed);
    if (parsed.hostname?.toLowerCase() !== LEGACY_MEDIA_HOST) return trimmed;
    parsed.protocol = targetProtocol;
    parsed.hostname = targetHostname;
    parsed.port = targetPort;
    return parsed.toString();
  } catch {
    return trimmed.replace(new RegExp(LEGACY_MEDIA_HOST.replace(/\./g, '\\.'), 'gi'), targetHostname);
  }
}

export function migrateLegacyMediaUrlsInLocalStorage(storageKeys, apiBaseUrl) {
  if (typeof window === 'undefined') return;
  if (!window.localStorage) return;
  if (!Array.isArray(storageKeys) || storageKeys.length === 0) return;

  for (const key of storageKeys) {
    const current = window.localStorage.getItem(key);
    if (!current) continue;
    const normalized = normalizeMediaUrl(current, apiBaseUrl);
    if (normalized && normalized !== current) {
      window.localStorage.setItem(key, normalized);
    }
  }
}

